<script lang="ts">
	import type { Component } from 'svelte';
	import IconDatabase from 'virtual:icons/material-symbols/manage-search-rounded';
	import IconWeb from 'virtual:icons/material-symbols/travel-explore-rounded';
	import IconLink from 'virtual:icons/material-symbols/link-rounded';
	import IconDocument from 'virtual:icons/material-symbols/description-rounded';
	import IconContext from 'virtual:icons/material-symbols/format-align-justify-rounded';
	import IconParliament from 'virtual:icons/material-symbols/account-balance-rounded';
	import IconLobby from 'virtual:icons/material-symbols/corporate-fare-rounded';
	import IconPolitician from 'virtual:icons/material-symbols/person-search-rounded';
	import IconVote from 'virtual:icons/material-symbols/how-to-vote-rounded';
	import IconQuestion from 'virtual:icons/material-symbols/forum-rounded';
	import IconPolicy from 'virtual:icons/material-symbols/policy-rounded';
	import IconFactCheck from 'virtual:icons/material-symbols/fact-check-rounded';
	import IconSearch from 'virtual:icons/material-symbols/search-rounded';
	import IconImage from 'virtual:icons/material-symbols/image-outline-rounded';

	const ICON_MAP: Record<string, Component> = {
		vector_search: IconDatabase,
		keyword_search: IconDatabase,
		get_document: IconDocument,
		get_neighboring_chunks: IconContext,
		web_search: IconWeb,
		fetch_url: IconLink,
		query_bundestag: IconParliament,
		query_parliament: IconParliament,
		query_parlament: IconParliament,
		search_lobbyregister: IconLobby,
		get_lobbyregister_entry: IconLobby,
		search_abgeordnetenwatch_politicians: IconPolitician,
		search_abgeordnetenwatch_polls: IconVote,
		query_kleine_anfragen: IconQuestion,
		search_fragdenstaat: IconPolicy,
		mark_briefing_status: IconFactCheck,
		generate_image: IconImage
	};

	let { name }: { name: string } = $props();
	const Icon = $derived(ICON_MAP[name] ?? IconSearch);
</script>

<Icon />
